import CreateWorkCycle from './CreateWorkCycle';

export default CreateWorkCycle;